module.exports = __webpack_public_path__ + "img/download-black.77e84596.svg";